import PaymentInfo, { PaymentInfoProps } from './PaymentInfo';

export type { PaymentInfoProps };
export default PaymentInfo;
